import _ from 'lodash';
import {
  SOURCE_INVENTORY_TABLE, SOURCE_LOTS_TABLE,
  SOURCE_TRANSFER_NOTES_TABLE,
  TRANSFER_NOTES_TABLE_NAME
} from "../../constants";
import i18n from "../../../shared/i18n";
import {store} from "@/plugins/vuex";
import TransferNoteSearchModel from "@/modules/transfer-notes/TransferNoteSearch.model";
import TransferNoteService from "@/modules/transfer-notes/TransferNoteService";
import InventoryService from "@/modules/inventory/InventoryService";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-no',
    search: '',
    searchModel: new TransferNoteSearchModel(),
    extraFilters: {},
    expand: '',
    toggleColumns: {
      fields: [...getDefaultTableFields(), ...differentFields],
      requiredFields: ['no', 'status'],
      defaultFields: ['no', 'status','type', 'issue_date', 'arrival_date', 'actions'],
    }
  }
};


let getDefaultTableFields = () => {
  return [
    {
      key: 'no',
      label: i18n.t('No'),
      sortable: true,
      tdClass: 'no_col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'status',
      label: i18n.t('Status'),
      sortable: true,
      tdClass: 'status_col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'type',
      label: i18n.t('Type'),
      sortable: false,
      tdClass: 'type_col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'issue_date',
      label: i18n.t('Issue Date'),
      sortable: true,
      tdClass: 'issue_date_col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'arrival_date',
      label: i18n.t('Arrival Date'),
      sortable: true,
      tdClass: 'arrival_date_col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'actions',
      label: i18n.t('Actions'),
      sortable: false,
      tdClass: 'actions-col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'service_provider',
      label: i18n.t('Service Provider'),
      sortable: true,
      tdClass: 'service_provider_col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'title',
      label: i18n.t('Title'),
      sortable: true,
      tdClass: 'title_col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'note',
      label: i18n.t('Note'),
      sortable: true,
      tdClass: 'note__col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'rep_user',
      label: i18n.t('Representative User'),
      sortable: true,
      tdClass: 'rep_user-col',
      isVisible: false,
      expand: 'rep_user'
    },
    {
      key: 'origin_item_location',
      label: i18n.t('Origin Item Location'),
      sortable: true,
      tdClass: 'origin-item-location-col',
      isVisible: false,
      expand: 'origin_item_location'
    },
    {
      key: 'destination_item_location',
      label: i18n.t('Destination Item Location'),
      sortable: true,
      tdClass: 'destination-item-location-col',
      isVisible: false,
      expand: 'destination_item_location'
    },
    {
      key: 'created_at',
      label: i18n.t('Created at / Created by'),
      sortable: true,
      tdClass: 'created-data-col',
      isVisible: false,
      expand: 'created_by'
    },
    {
      key: 'updated_at',
      label: i18n.t('Updated at / Updated by'),
      sortable: true,
      tdClass: 'updated-data-col',
      isVisible: false,
      expand: 'updated_by'
    },
    {
      key: 'contract_status',
      label: i18n.t('Contract Status'),
      sortable: false,
      tdClass: 'contract-status-col',
      isVisible: false,
      expand: 'contract_status'
    },
    {
      key: 'total_items',
      label: i18n.t('Items'),
      sortable: false,
      tdClass: 'total_items-col',
      isVisible: false,
      expand: 'total_items'
    },
  ]
}

export default {
  namespaced: true,
  state: {
    modal: {
      show: false,
      object: null,
      loading: null,
      source: null
    },
    itemModal: {
      show: false,
      object: null,
      source: null
    },
    tableSource: null,
    tableData: {
      transferNote: getDefaultTableData(),
    },
    types: [
      {key: i18n.t('Internal'), value: 'internal'},
      {key: i18n.t('External'), value: 'external'},
    ],
    statuses: [
      {key: i18n.t('Draft'), value: 'draft'},
      {key: i18n.t('Ready to Transfer'), value: 'ready_to_transfer'},
      {key: i18n.t('In Transit'), value: 'in_transit'},
      {key: i18n.t('Received at Destination'), value: 'received_at_destination'},
    ],
  },
  actions: {
    async getModalObject({commit, state}, {uuid, source}) {
      state.modal.loading = true
      let response = await TransferNoteService.getTransferNote(uuid, {
        expand: [
          'rep_user',
          'destination_item_location',
          'origin_item_location',
          'transfer_note_items.inventory.latest_reservation.auction',
          'transfer_note_items.inventory.department',
          'transfer_note_items.inventory.category',
          'transfer_note_items.inventory.item_location',
          'transfer_note_items.new_item_location',
          'transfer_note_items.created_by',
          'transfer_note_items.inventory.custom_statuses',
        ].join(',')
      });
      state.modal.loading = false
      if (response.success) {

        response.body.transfer_note_items.sort((a, b) => {
          if (a.ordering === null) return 1; // Move null to the end
          if (b.ordering === null) return -1; // Move null to the end
          return a.ordering - b.ordering; // Ascending order
        });

        commit('updateModalObject', {object: _.cloneDeep(response.body), source})
      } else {
        state.modal.error = response.toastError;
      }
    },
    async getItemsForCreate({state, commit}, {uuids, source}) {
      state.modal.loading = true
      let response = await InventoryService.getInventories({
        uuids: uuids,
        expand: [
          'latest_reservation.auction',
          'department',
          'category',
          'item_location',
        ].join(','),
        limit: 100
      });
      state.modal.loading = false
      if (response.success) {
        let ordering = 0
        commit('updateModalObject', {
          object: {
            transfer_note_items: response.body.results.map(i => {
              return {inventory: i, inventory_uuid: i.uuid, ordering: ordering++}
            })
          }, source: source
        })
      } else {
        state.modal.error = response.toastError;
      }
    },
    showModal({commit}, {object = {}, source} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source});
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    showItemModal({commit}, {object = {}, source} = {}) {
      commit('showItemModal', {object: _.cloneDeep(object), source});
    },
    hideItemModal({commit}) {
      commit('hideItemModal');
    },
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new TransferNoteSearchModel({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      dispatch('getTableData');
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await TransferNoteService.getTransferNotes(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }

      return response;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: `${TRANSFER_NOTES_TABLE_NAME}.${state.tableSource}`
      })

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: ordering,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      const defaultExpand = currentTableData.expand
      const expand = currentTableData.toggleColumns.fields
        .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',')

      data.expand = `${expand},${defaultExpand}`;

      return data;
    },
    async updateTableSource({state}, {extraFilters, source}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
    },
    async createTransferNote({dispatch, state}, data) {
      let response = await TransferNoteService.createTransferNote(data, '');
      if (response.success) {
        if (state.modal.source === SOURCE_INVENTORY_TABLE) {
          dispatch('inventory/getTableData', null, {root: true})
        } else if (state.modal.source === SOURCE_TRANSFER_NOTES_TABLE) {
          dispatch('getTableData')
        }
      }
      return response;
    },
    async updateTransferNote({state, dispatch}, data) {
      let response = await TransferNoteService.updateTransferNote(data.uuid, data, '');

      if (response.success) {
        if (state.modal.source === SOURCE_TRANSFER_NOTES_TABLE) {
          dispatch('getTableData')
        } else if (state.modal.source === SOURCE_INVENTORY_TABLE) {
          dispatch('inventory/getTableData', null, {root: true})
        } else if (state.modal.source === SOURCE_LOTS_TABLE) {
          dispatch('lots/getTableData', null, {root: true})
        }
      }

      return response;
    },
    async removeTransferNote({dispatch}, item) {
      let response = await TransferNoteService.removeTransferNote(item.uuid);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
  },
  mutations: {
    showModal: (state, {object, source}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
    },
    updateModalObject: (state, {object, source}) => {
      state.modal.object = object;
      state.modal.source = source;
    },
    hideModal: state => {
      state.modal.show = false
      state.modal.source = null
      state.modal.object = null
    },
    showItemModal: (state, {object, source}) => {
      state.itemModal.show = true;
      state.itemModal.object = object;
      state.itemModal.source = source;
    },
    hideItemModal: state => {
      state.itemModal.show = false
      state.itemModal.source = null
      state.itemModal.object = null
    },
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateTransferNote: (state, item) => {
      const index = state.tableData[state.tableSource].rows.findIndex(r => r.uuid === item.uuid);
      state.tableData[state.tableSource].rows[index] = {...state.tableData[state.tableSource].rows[index], ...item};
      state.tableData[state.tableSource].rows = [...state.tableData[state.tableSource].rows];
    },
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  }
}
